import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, BACKGROUND_GRAY, ELEMENT_GRAY, INACTIVE_GRAY, LINE_GRAY, NIGHTINGALE_BLACK, RIOJA_RED, RIOJA_RED_FOCUSED, SENSATION_WHITE } from '../colors';
const primaryStyle = {
  noShadow: false,
  noShadowActive: false,
  noShadowHover: false,
  noShadowFocus: false,
  noShadowDisabled: false,
  color: SENSATION_WHITE,
  activeColor: SENSATION_WHITE,
  hoverColor: SENSATION_WHITE,
  focusColor: SENSATION_WHITE,
  disabledColor: ELEMENT_GRAY,
  iconColor: SENSATION_WHITE,
  activeIconColor: SENSATION_WHITE,
  hoverIconColor: SENSATION_WHITE,
  focusIconColor: SENSATION_WHITE,
  disabledIconColor: ELEMENT_GRAY,
  backgroundColor: ADVENTURE_GREEN,
  activeBackgroundColor: ADVENTURE_GREEN_FOCUSED,
  hoverBackgroundColor: ADVENTURE_GREEN,
  focusBackgroundColor: ADVENTURE_GREEN,
  disabledBackgroundColor: LINE_GRAY,
  borderColor: null,
  hoverBorderColor: null,
  activeBorderColor: null,
  focusBorderColor: null,
  disabledBorderColor: null
};
const secondaryStyle = {
  ...primaryStyle,
  color: ADVENTURE_GREEN,
  activeColor: ADVENTURE_GREEN_FOCUSED,
  hoverColor: ADVENTURE_GREEN,
  focusColor: ADVENTURE_GREEN,
  iconColor: ADVENTURE_GREEN,
  activeIconColor: ADVENTURE_GREEN_FOCUSED,
  hoverIconColor: ADVENTURE_GREEN,
  focusIconColor: ADVENTURE_GREEN,
  backgroundColor: SENSATION_WHITE,
  activeBackgroundColor: BACKGROUND_GRAY,
  hoverBackgroundColor: SENSATION_WHITE,
  focusBackgroundColor: SENSATION_WHITE
};
const alarmStyle = {
  ...primaryStyle,
  backgroundColor: RIOJA_RED,
  activeBackgroundColor: RIOJA_RED_FOCUSED,
  hoverBackgroundColor: RIOJA_RED,
  focusBackgroundColor: RIOJA_RED
};
const ghostStyle = {
  ...secondaryStyle,
  color: NIGHTINGALE_BLACK,
  activeColor: NIGHTINGALE_BLACK,
  hoverColor: NIGHTINGALE_BLACK,
  focusColor: NIGHTINGALE_BLACK,
  iconColor: ELEMENT_GRAY,
  activeIconColor: INACTIVE_GRAY,
  hoverIconColor: ELEMENT_GRAY,
  focusIconColor: ELEMENT_GRAY
};
const transparentStyle = {
  ...ghostStyle,
  noShadow: true,
  color: SENSATION_WHITE,
  iconColor: SENSATION_WHITE,
  backgroundColor: 'transparent',
  borderColor: SENSATION_WHITE,
  hoverBorderColor: 'transparent',
  activeBorderColor: 'transparent',
  focusBorderColor: 'transparent'
};
export const buttonStyle = {
  primary: primaryStyle,
  secondary: secondaryStyle,
  alarm: alarmStyle,
  ghost: ghostStyle,
  transparent: transparentStyle
};